import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccessService {
  constructor() {}

  private authSubject = new Subject<boolean>();
  authState$ = this.authSubject.asObservable();
  _authenticated = false;

  get access() {
    const access = localStorage.getItem('access');
    return access ? JSON.parse(access) : null;
  }

  set access(value: any) {
    localStorage.setItem('access', JSON.stringify(value));
  }

  check(): Observable<boolean> {
    if (this._authenticated) return of(true);
    else if (!this.access || !this.access.token) return of(false);

    return of(true);
  }

  updateImageUrl = (imageUrl: string) => {
    const data = this.access;
    data.imageUrl = imageUrl;
    this.access = data;
  };

  sair = () => {
    localStorage.removeItem('access');
    this.setAuthState(false);
  };

  setAuthState(isAuthenticated: boolean) {
    this._authenticated = isAuthenticated;
    this.authSubject.next(isAuthenticated);
  }
}
